import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Stack,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import no_member_icon from "../../../assets/images/chats/no_member_icon.svg";
import { useSelector } from "react-redux";
import {
  AccountLevelArkchatPermission,
  GroupLevelArkchatPermission,
  InviteType,
  UI_FEATURES,
} from "../../../utils/constant";
import { useDispatch } from "react-redux";
import { requestAccountPeopleForGroup, requestAddmemberInGroup } from "../../../appStore/actions/ArkchatGroup/action";
import InputDialogComponent from "../../../components/InputDialog";
import { createStyledIndicatorButton } from "../../../common/StyledComponents/SideBarComponents";
import AlertPopUp from "../../../common/AlertPopUp";
import { groupExternalMember } from "../../../utils/externalMemberGroping";
import { useTranslation } from "react-i18next";
import { showToastMsg } from "../../../appStore/actions/global/action";
import SelectCheckBox from "../../../assets/images/chats/selectcheckbox.svg";

import { crossIcon, crossIconDiv } from "../../../assets/commonFunction";
import { canManageGroup } from "../../../utils/helper";
import Switchs from "./Switchs";
import useStableCallbacks from "../../../customHooks/useStableCallbacks";
import useProgressiveList from "../../../customHooks/useProgressiveList";
const memberSelectionIconSize = "30px";
const checkboxIconStyle = {
  width: memberSelectionIconSize,
  height: memberSelectionIconSize,
  display: "block",
};
const memberIndicatorStyle = {
  width: memberSelectionIconSize,
  height: memberSelectionIconSize,
  minWidth: memberSelectionIconSize,
  minHeight: memberSelectionIconSize,
  color: "#183243",
  padding: 0,
  overflow: "hidden",
  "& img": {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
};
const classes = {
  drawerBody: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    height: "100%",
  },
  header: {
    backgroundColor: "#183243",
    color: "#0000",
    padding: "0 0.3rem",
    minHeight: "38px",
  },
  iconDiv: crossIconDiv,

  internalExternalButton: {
    background: "white",
    border: "1px solid #183243",
    color: "#183243",
    borderRadius: "0px",
    fontSize: "0.75rem",
    textTransform: "none",
    "&:hover": {
      background: "white",
    },
  },

  activeButton: {
    "&:hover": {
      background: "#183243",
    },
    background: "#183243",
    borderRadius: "0px",
    color: "white",
    fontSize: "0.75rem",
    textTransform: "none",
    border: "1px solid #183243",
  },

  iconn: { ...crossIcon, color: "#FFFFFF" },
  radiogp: {
    display: "block",
  },
  groupMember: {
    backgroundColor: "#F3F3F3",
    padding: "20px 10px",
  },

  // add group member
  addgmember: {
    transform: "translate(0, 70%)",
    textAlign: "center",
  },
  // add group member
};

const NameBadge = createStyledIndicatorButton("#E3E1E1");
const isAccountOwnerMember = (member) =>
  member?.inviteType === InviteType?.ownerInviteType;

// One account member in the list. Memoized: ticking one re-renders only
// that row (each tick re-rendered every member of the account).
const InternalInviteRow = React.memo(function InternalInviteRow({
  item,
  selected,
  isManager,
  viewerIsAccountOwner,
  onSelect,
  onToggleManager,
}) {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      padding="0rem 1.18rem 0rem 0.75rem"
    >
      <FormControlLabel
        control={
          <Checkbox
            sx={{
              "& .MuiSvgIcon-root": {
                fontSize: 30,
                color: "#183243",
              },
            }}
            checked={selected}
            disabled={
              isAccountOwnerMember(item) &&
              selected
            }
            onChange={(event) => onSelect(event, item)}
            checkedIcon={
              <img
                style={checkboxIconStyle}
                src={SelectCheckBox}
                alt="selected"
              />
            }
            icon={
              <NameBadge
                sx={memberIndicatorStyle}
                size="small"
                variant="contained"
              >
                <Typography
                  color={"#183243"}
                  fontSize={"0.75rem"}
                >
                  {item?.userInfo?.firstName &&
                    item?.userInfo?.firstName[0]}
                </Typography>
              </NameBadge>
            }
          />
        }
        label={`${item?.userInfo?.firstName} ${item?.userInfo?.lastName}`}
      />
      <Box display="flex" alignItems="center" gap="0.75rem">
        {UI_FEATURES.groupManagerToggle &&
          selected &&
          item?.inviteType !== InviteType?.ownerInviteType &&
          item?.permission !== AccountLevelArkchatPermission?.ADMIN && (
          <Switchs
            switchLabel="Manager"
            name={String(item?.userId)}
            checked={isManager}
            handleChange={(event) =>
              onToggleManager(event, item)
            }
          />
        )}
        {item?.inviteType === InviteType?.ownerInviteType &&
          (item?.permission ===
            AccountLevelArkchatPermission?.ADMIN ||
            viewerIsAccountOwner) && (
            <Box>
              <Typography>Owner</Typography>
            </Box>
          )}
        {item?.inviteType === InviteType?.internal &&
          item?.permission ===
            AccountLevelArkchatPermission?.ADMIN && (
            <Box>
              <Typography>Admin</Typography>
            </Box>
          )}
        {item?.permission ===
          AccountLevelArkchatPermission?.USER && (
          // don't remove it, this can be enabled in future
          // <FormControlLabel
          //   control={
          //     <Switchs
          //       switchLabel="Manager"
          //       checked={groupMemeberPermission?.includes(
          //         item?.userId
          //       )}
          //       handleChange={(event) =>
          //         handleChangeInternalMemberGrpPermission(
          //           event,
          //           item
          //         )
          //       }
          //     />
          //   }
          // />
          <Box>
            <Typography>User</Typography>
          </Box>
        )}
      </Box>
    </Stack>
  );
});

const InviteGroupMember = ({ handleCloseAddPeopleDrawer, handleOpenMenu, isOpen = true }) => {
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });
  const [activeButton, setActiveButton] = useState("internal");
  
  const userData = useSelector((state) => state?.profile);
  // The store holds the group's people (its members and the account's
  // admins); adding needs everyone in the account. They're loaded when this
  // opens, each with their permission in the group taken from the store,
  // which follows adds and removes live.
  const groupPeople = useSelector(
    (state) => state?.arkchatgroup?.groupmember
  );
  const selectedGroup = useSelector(
    (state) => state?.appStateData?.selectedGroupData
  );
  const dispatch = useDispatch();
  // (This stays mounted while the drawer is closed: load when it opens.)
  const [accountPeople, setAccountPeople] = useState(null);
  useEffect(() => {
    setAccountPeople(null);
  }, [selectedGroup?.id]);
  useEffect(() => {
    if (!isOpen || !selectedGroup?.id) return undefined;
    let cancelled = false;
    dispatch(
      requestAccountPeopleForGroup({
        group_id: selectedGroup.id,
        target_subscriber_id:
          selectedGroup?.subscriberId ?? userData?.profileData?.data?.activeSubscriber?.id,
      }),
    ).then((res) => {
      if (!cancelled && res) setAccountPeople(res);
    });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, selectedGroup?.id, isOpen]);
  const groupmemberdetails = useMemo(() => {
    if (!accountPeople) return groupPeople;
    const permissionInGroup = new Map(
      [...(groupPeople?.internalMember || []), ...(groupPeople?.externalMember || [])]
        .map((p) => [p?.userId, p?.permissionType]),
    );
    const withGroupPermission = (p) => ({
      ...p,
      permissionType: permissionInGroup.get(p?.userId) ?? GroupLevelArkchatPermission.REMOVE,
    });
    return {
      ...groupPeople,
      internalMember: accountPeople.internalMember.map(withGroupPermission),
      externalMember: accountPeople.externalMember.map(withGroupPermission),
    };
  }, [accountPeople, groupPeople]);
  const [groupmember, setGroupMember] = useState([]);
  const [externalGroupMember, setExternalGroupMember] = useState({});
  const [groupMemeberPermission, setGroupMemeberPermission] = useState([]);
  // The group's managers (its Owner, the creator, counts as one).
  const [groupManagerIds, setGroupManagerIds] = useState([]);
  const [externalMemberData, setExternalMemberData] = useState([]);
  const [isownershipright, setownershipright] = useState({
    isOpen: false,
    reqBody: null,
    isChecked: false,
    key: "",
  });
  const [isPermissionModalOpen, setPermissionModal] = useState(false);
  const [alertContent, setAlertContent] = useState(appContent?.KEY165);
  useEffect(() => {
    if (groupmemberdetails) {
      const combinedArray = [
        ...groupmemberdetails?.internalMember,
        ...groupmemberdetails?.externalMember,
      ];
      if (groupmemberdetails?.externalMember?.length > 0) {
        const groupedExternalData = groupExternalMember(
          groupmemberdetails?.externalMember,
          false, // isRecipientList
          appContent?.KEY34
        );

        setExternalMemberData(groupedExternalData);
        let extgrpMemberObj = {};
        groupedExternalData.forEach((company, index) => {
          const companyValues = Object.values(company)[0];
          const filteredItems = companyValues?.filter(
            (item) =>
              item?.permissionType !== GroupLevelArkchatPermission.REMOVE
          );
          const userIds = filteredItems?.map((item) => item?.userId);
          const companyName = Object.keys(company)[0];
          const companyUserId = { [companyName]: userIds };
          extgrpMemberObj = { ...extgrpMemberObj, ...companyUserId };
        });
        setExternalGroupMember({ ...extgrpMemberObj });
      }
      const membersid = combinedArray
        ?.filter(
          (item) => item?.permissionType != GroupLevelArkchatPermission.REMOVE
        )
        .map((item) => item?.userId);

      const permissionUserId = combinedArray
        ?.filter(
          (item) =>
            item?.permissionType == GroupLevelArkchatPermission?.ADMIN ||
            item?.permissionType == GroupLevelArkchatPermission?.MANAGER
        )
        .map((item) => item?.userId);
      setGroupMemeberPermission(permissionUserId);
      setGroupManagerIds(
        combinedArray
          ?.filter(
            (item) =>
              item?.permissionType === GroupLevelArkchatPermission.MANAGER ||
              item?.permissionType === GroupLevelArkchatPermission.OWNER
          )
          .map((item) => item?.userId)
      );
      setGroupMember(membersid);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupmemberdetails]);

  const handleCopyClickCallback = (type) => {
    if (type === "error") {
      dispatch(showToastMsg(appContent?.KEY52));
    } else {
      dispatch(showToastMsg(appContent?.KEY53));
    }
  };



  // const handleOpenMenu = async (event) => {
  //   let activePermission = userData?.profileData?.data?.activePermission;
  //   let isManagerData = groupmemberdetails?.internalMember?.find(
  //     (data) => data?.userId === userData?.profileData?.data?.id
  //   );
  //   if (
  //     activePermission == GroupLevelArkchatPermission.ADMIN ||
  //     activePermission == GroupLevelArkchatPermission.MANAGER ||
  //     isManagerData?.permissionType === GroupLevelArkchatPermission.MANAGER
  //   ) {
  //     if (activeButton === "internal") {
  //       const groupId = selectedGroup?.id;
  //       const res = await dispatch(getInviteUrl(1, groupId));
  //       if (res?.status) {
  //         handleCopyClick(res?.data?.inviteMessage, handleCopyClickCallback);
  //       }
  //     } else {
  //       const groupId = selectedGroup?.id;
  //       const res = await dispatch(getInviteUrl(2, groupId));
  //       if (res?.status) {
  //         handleCopyClick(res?.data?.inviteMessage, handleCopyClickCallback);
  //       }
  //     }
  //   } else {
  //     setPermissionModal(true);
  //   }
  // };

  const handleClickExternal = () => {
    if (selectedGroup?.isExternal) {
      setAlertContent(appContent?.KEY170);
      setPermissionModal(true);
    } else {
      setActiveButton("external");
    }
  };

  const handleClickInternal = () => {
    setActiveButton("internal");
  };

  const handleAddRemoveInternalMemberFromGroup = async (
    selectedPerson,
    permission_type
  ) => {
    const reqBody = {
      group_id: selectedGroup?.id,
      members: [
        {
          user_id: selectedPerson?.userId,
          target_subscriber_id: selectedGroup?.isExternal
            ? userData?.profileData?.data?.activeSubscriber?.id
            : selectedPerson?.targetSubscriberId,
        },
      ],
      is_external: selectedGroup?.isExternal,
      permission_type,
      subscriber_id: userData?.profileData?.data?.activeSubscriber?.id,
    };
    return dispatch(requestAddmemberInGroup(reqBody));
  };

  // Make a member (an account User, or any external member) one of the
  // group's managers, or an ordinary member again. Admins and the owner are
  // managers by default, so they have no toggle.
  const handleToggleGroupManager = async (event, member, isExternal = false) => {
    const makeManager = event.target.checked;
    const permissionType = makeManager
      ? GroupLevelArkchatPermission.MANAGER
      : GroupLevelArkchatPermission.USER;
    const previous = groupManagerIds;
    const others = groupManagerIds.filter((id) => id !== member?.userId);
    setGroupManagerIds(makeManager ? [...others, member?.userId] : others);
    const res = isExternal
      ? await handleAddRemoveExternalMemberFromGroup(member, permissionType, true)
      : await handleAddRemoveInternalMemberFromGroup(member, permissionType);
    if (!res?.status) setGroupManagerIds(previous);
  };

  // The account owner can only leave a group themselves (Exit Group);
  // nobody can remove them.
  const handleSelectPerson = async (event, selectedPerson) => {
    if (!event.target.checked && isAccountOwnerMember(selectedPerson)) {
      dispatch(showToastMsg("The account owner can't be removed from a group. They can exit it themselves."));
      return;
    }
    let isManagerData = groupmemberdetails?.internalMember?.find(
      (data) => data?.userId === userData?.profileData?.data?.id
    );
    if (
      canManageGroup(
        userData?.profileData?.data,
        isManagerData?.permissionType ?? selectedGroup?.permissionType,
        selectedGroup?.isExternal
      )
    ) {
      if (event.target.checked) {
        const updatedSelectedPerson = [...groupmember, selectedPerson?.userId];
        setGroupMember(updatedSelectedPerson);
        handleAddRemoveInternalMemberFromGroup(
          selectedPerson,
          GroupLevelArkchatPermission.USER
        );
      } else {
        const updatedSelectedPerson = groupmember?.filter(
          (item) => item !== selectedPerson?.userId
        );
        const updatedSelectedPersonPermission = groupMemeberPermission?.filter(
          (item) => item !== selectedPerson?.userId
        );
        setGroupMemeberPermission(updatedSelectedPersonPermission);
        setGroupMember(updatedSelectedPerson);
        handleAddRemoveInternalMemberFromGroup(
          selectedPerson,
          GroupLevelArkchatPermission.REMOVE
        );
      }
    } //4=Manager of group)
    else {
      setPermissionModal(true);
    }
  };
  const handleAddRemoveExternalMemberFromGroup = async (
    selectedPerson,
    permission_type,
    isSingleSelect
  ) => {
    if (isSingleSelect) {
      const reqBody = {
        group_id: selectedGroup?.id,
        members: [
          {
            user_id: selectedPerson?.userId,
            target_subscriber_id: selectedPerson?.targetSubscriberId,
          },
        ],
        is_external: true,
        permission_type,
        subscriber_id: userData?.profileData?.data?.activeSubscriber?.id,
      };
      return dispatch(requestAddmemberInGroup(reqBody));
    } else {
      const selectedUserData = selectedPerson?.map((user) => ({
        user_id: user?.userId,
        target_subscriber_id: user?.targetSubscriberId,
      }));
      const reqBody = {
        group_id: selectedGroup?.id,
        members: selectedUserData,
        is_external: true,
        permission_type,
        subscriber_id: userData?.profileData?.data?.activeSubscriber?.id,
      };
      const response = await dispatch(requestAddmemberInGroup(reqBody));
    }
  };

  const handleSelectExternalPerson = async (
    event,
    selectedPerson,
    companyName
  ) => {
    let isManagerData = groupmemberdetails?.internalMember?.find(
      (data) => data?.userId === userData?.profileData?.data?.id
    );
    if (
      canManageGroup(
        userData?.profileData?.data,
        isManagerData?.permissionType ?? selectedGroup?.permissionType,
        selectedGroup?.isExternal
      )
    ) {
      if (event.target.checked) {
        if (externalGroupMember[companyName]?.length > 0) {
          const companyUserId = {
            [companyName]: [
              ...externalGroupMember[companyName],
              selectedPerson?.userId,
            ],
          };
          setExternalGroupMember({ ...externalGroupMember, ...companyUserId });
          handleAddRemoveExternalMemberFromGroup(
            selectedPerson,
            GroupLevelArkchatPermission.USER,
            true
          );
        } else {
          const companyUserId = { [companyName]: [selectedPerson?.userId] };
          setExternalGroupMember({ ...externalGroupMember, ...companyUserId });
          handleAddRemoveExternalMemberFromGroup(
            selectedPerson,
            GroupLevelArkchatPermission.USER,
            true
          );
        }
      } else {
        const updatedCompanyUserId = externalGroupMember[companyName]?.filter(
          (item) => item !== selectedPerson?.userId
        );
        const updatedData = { [companyName]: updatedCompanyUserId };
        setExternalGroupMember({ ...externalGroupMember, ...updatedData });
        handleAddRemoveExternalMemberFromGroup(
          selectedPerson,
          GroupLevelArkchatPermission.REMOVE,
          true
        );
      }
    } else {
      setPermissionModal(true);
    }
  };

  const handleSelecteAllExternalCompanyMember = (
    event,
    selectedCompanyPerson,
    companyName
  ) => {
    let isManagerData = groupmemberdetails?.internalMember?.find(
      (data) => data?.userId === userData?.profileData?.data?.id
    );
    if (
      canManageGroup(
        userData?.profileData?.data,
        isManagerData?.permissionType ?? selectedGroup?.permissionType,
        selectedGroup?.isExternal
      )
    ) {
      if (event.target.checked) {
        const userIdData = selectedCompanyPerson[companyName]?.map(
          (user) => user?.userId
        );
        const companyUserId = { [companyName]: userIdData };
        setExternalGroupMember({ ...externalGroupMember, ...companyUserId });
        handleAddRemoveExternalMemberFromGroup(
          selectedCompanyPerson[companyName],
          GroupLevelArkchatPermission.USER,
          false
        );
      } else {
        const updatedExternalGroupMember = { ...externalGroupMember };
        delete updatedExternalGroupMember[companyName];
        setExternalGroupMember(updatedExternalGroupMember);
        handleAddRemoveExternalMemberFromGroup(
          selectedCompanyPerson[companyName],
          GroupLevelArkchatPermission.REMOVE,
          false
        );
      }
    } else {
      setPermissionModal(true);
    }
  };

  const handleOkayButtonClicked = async () => {
    setGroupMember([...groupmember, parseInt(isownershipright?.key)]);

    setGroupMemeberPermission({
      ...groupMemeberPermission,
      [isownershipright?.key]: isownershipright?.isChecked,
    });

    const response = await dispatch(
      requestAddmemberInGroup(isownershipright?.reqBody)
    );
    if (response) {
      setownershipright({
        ...isownershipright,
        isOpen: false,
      });
    }
  };

  const handleCancelButtonClick = () => {
    setownershipright({
      ...isownershipright,
      isOpen: false,
    });
  };
  // Looked up once per render instead of a scan per member; the rows'
  // handlers keep their identity (see InternalInviteRow).
  const selectedIds = useMemo(() => new Set(groupmember || []), [groupmember]);
  const managerIds = useMemo(() => new Set(groupManagerIds || []), [groupManagerIds]);
  const stable = useStableCallbacks({ handleSelectPerson, handleToggleGroupManager });
  // A big account's people are built a part at a time as the list scrolls
  // (the tab shown: internal people, or external ones by company): building
  // every row at once took most of a second.
  const externalRowCount = externalMemberData.reduce((n, company) => n + (Object.values(company)[0]?.length || 0), 0);
  const tabRows = activeButton === "internal" ? groupmemberdetails?.internalMember?.length || 0 : externalRowCount;
  const [shownRows, listRef, moreRef] = useProgressiveList(tabRows);
  const visibleExternal = [];
  let externalBudget = shownRows;
  for (const company of externalMemberData) {
    if (externalBudget <= 0) break;
    const rows = (Object.values(company)[0] || []).slice(0, externalBudget);
    externalBudget -= rows.length;
    visibleExternal.push({ company, rows });
  }

  return (
    <>
      <AlertPopUp
        title={"Alert."}
        bodyContent={alertContent}
        open={isPermissionModalOpen}
        closeModal={setPermissionModal}
      />
      
      <Box sx={classes.drawerBody}>
        <Stack>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={classes.header}
          >
            <Stack direction="row" alignItems="center" spacing={2}>
              <Typography sx={classes.iconDiv}>
                <CloseIcon
                  sx={classes.iconn}
                  onClick={handleCloseAddPeopleDrawer}
                />
              </Typography>
              <Typography color={"white"} fontSize={"14px"} fontWeight={400}>
                Add group members
              </Typography>
            </Stack>
            {/* <Typography color={"black"}>Right</Typography> */}
          </Stack>

          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={1}
            padding="12px"
            mt={"0.4rem"}
            mb={"0.4rem"}
          >
            <Stack
              direction="row"
              justifyContent="left"
              alignItems="center"
              spacing={1}
            >
              <Button
                sx={
                  activeButton == "internal"
                    ? classes.activeButton
                    : classes.internalExternalButton
                }
                variant="contained"
                onClick={handleClickInternal}
              >
                Internal
              </Button>
              <Button
                sx={
                  activeButton == "external"
                    ? classes.activeButton
                    : classes.internalExternalButton
                }
                variant="contained"
                onClick={handleClickExternal}
              >
                External
              </Button>
            </Stack>
           
              <Box position={"relative"}>
                <Button
                  onClick={handleOpenMenu}
                  sx={{
                    background: "#DB0011",
                    color: "white",
                    borderRadius: "2px",
                    fontSize: "0.75rem",
                    textTransform: "none",
                    "&:hover": {
                      background: "#DB0011",
                      color: "white",
                    },
                  }}
                  variant="contained"
                >
                  Invite
                </Button>
              </Box>
            
          </Stack>
          <Box
            ref={listRef}
            sx={{
              overflowX: "hidden",
              overflowY: "auto",
              height:
                activeButton == "internal"
                  ? "calc(100vh - 13rem)"
                  : "calc(100vh - 16rem)",
              "&::-webkit-scrollbar": {
                width: "1px",
              },
              "&::-webkit-scrollbar-track": {
                background: "#183243",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "grey",
              },
            }}
          >
            {activeButton == "internal" && (
              <Box>
                {groupmemberdetails?.internalMember?.slice(0, shownRows).map((item) => (
                  <InternalInviteRow
                    key={item?.userId + "internalInvitegrpmember"}
                    item={item}
                    selected={selectedIds.has(item?.userId)}
                    isManager={managerIds.has(item?.userId)}
                    viewerIsAccountOwner={userData?.profileData?.data?.accountOwner}
                    onSelect={stable.handleSelectPerson}
                    onToggleManager={stable.handleToggleGroupManager}
                  />
                ))}
              </Box>
            )}

            {activeButton == "external" && (
              <Box>
                {visibleExternal.map(({ company, rows }, index) => (
                  <Box padding="0px 19px 6px 12px">
                    <FormControlLabel
                      sx={{
                        ".MuiFormControlLabel-label": {
                          fontWeight: 500,
                          color: "#000000",
                        },
                      }}
                      control={
                        <Checkbox
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: 30,
                              color: "#183243",
                            },
                          }}
                          checked={
                            Object.values(company)[0]?.length ===
                            externalGroupMember[Object.keys(company)[0]]?.length
                          }
                          onChange={(event) =>
                            handleSelecteAllExternalCompanyMember(
                              event,
                              company,
                              Object.keys(company)[0]
                            )
                          }
                          checkedIcon={
                            <img
                              style={checkboxIconStyle}
                              src={SelectCheckBox}
                              alt="selected"
                            />
                          }
                          icon={
                            <NameBadge
                              sx={memberIndicatorStyle}
                              size="small"
                              variant="contained"
                            >
                              <Typography
                                color={"#183243"}
                                fontSize={"0.75rem"}
                                fontWeight={600}
                              >
                                {Object.keys(company)[0] &&
                                  Object.keys(company)[0][0]}
                              </Typography>
                            </NameBadge>
                          }
                        />
                      }
                      label={
                        <Typography fontWeight={600} fontSize={"0.88rem"}>
                          {Object.keys(company)[0]}
                        </Typography>
                      }
                    />
                    {rows.map((item, i) => (
                      <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={1}
                        key={item?.userId + "externalInvitegrpmember"}
                      >
                        <Box width={"62%"} padding={"0rem 0rem 0rem 1.2rem"}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                sx={{
                                  "& .MuiSvgIcon-root": {
                                    fontSize: 25,
                                    color: "#183243",
                                  },
                                }}
                                checked={
                                  externalGroupMember[Object.keys(company)[0]]
                                    ?.length > 0 &&
                                  externalGroupMember[
                                    Object.keys(company)[0]
                                  ]?.includes(item?.userId)
                                }
                                onChange={(event) =>
                                  handleSelectExternalPerson(
                                    event,
                                    item,
                                    Object.keys(company)[0]
                                  )
                                }
                                checkedIcon={
                                  <img
                                    style={checkboxIconStyle}
                                    src={SelectCheckBox}
                                    alt="selected"
                                  />
                                }
                                icon={
                                  <NameBadge
                                    sx={memberIndicatorStyle}
                                    size="small"
                                    variant="contained"
                                  >
                                    <Typography
                                      color={"#183243"}
                                      fontSize={"0.75rem"}
                                    >
                                      {item?.userInfo?.firstName &&
                                        item?.userInfo?.firstName[0]}
                                    </Typography>
                                  </NameBadge>
                                }
                              />
                            }
                            label={`${item?.userInfo?.firstName} ${item?.userInfo?.lastName}`}
                          />
                        </Box>
                        {UI_FEATURES.groupManagerToggle &&
                          externalGroupMember[Object.keys(company)[0]]?.includes(
                          item?.userId
                        ) && (
                          <Switchs
                            switchLabel="Manager"
                            name={String(item?.userId)}
                            checked={groupManagerIds.includes(item?.userId)}
                            handleChange={(event) =>
                              handleToggleGroupManager(event, item, true)
                            }
                          />
                        )}
                        {/* <FormControlLabel
                        control={
                          <Switchs
                            switchLabel="Owner"
                            name={item?.userId}
                            checked={groupMemeberPermission?.[item?.userId]}
                            handleChange={(event) =>
                              handleChangeInternalMemberGrpPermission(
                                event,
                                item
                              )
                            }
                          />
                        }
                      /> */}
                      </Stack>
                    ))}
                  </Box>
                ))}
              </Box>
            )}

            {shownRows < tabRows && <Box ref={moreRef} height="1px" />}
            {groupmemberdetails?.externalMember?.length == 0 &&
              activeButton == "external" && (
                <Stack alignItems="center" sx={classes.addgmember}>
                  <img src={no_member_icon} alt="no_member" />
                  <Typography
                    fontSize={14}
                    width={"20rem"}
                    marginTop={"0.93rem"}
                  >
                    You don’t have any External team members. Invite your
                    vendors, partners and customers to collaborate with you.
                  </Typography>
                </Stack>
              )}
          </Box>
        </Stack>

        {activeButton == "external" && (
          <Stack
            alignItems="center"
            spacing={1}
            padding="0.75rem 0rem"
            margin={"0 auto"}
            width={"22.5rem"}
          >
            <Typography fontSize={12} textAlign={"center"}>
              <Typography fontSize={12} fontWeight={600} display={"inline"}>
                Invite only one person from a firm.{" "}
              </Typography>
              Their firm joins your account and adds its team to collaborate
              with you. Invite freelancers individually.
            </Typography>
          </Stack>
        )}
        {isownershipright?.isOpen && (
          <InputDialogComponent
            title="Ownership rights"
            isType="ownershipright"
            open={isownershipright?.isOpen}
            handleClose={() => {
              setownershipright({
                ...isownershipright,
                isOpen: false,
              });
            }}
            btnLabel="Cancel"
            alternateBtnLabel="Yes"
            handleAlternateBtnClick={handleOkayButtonClicked}
            onClick={handleCancelButtonClick}
          />
        )}
      </Box>
    </>
  );
};

export default InviteGroupMember;
